import { forwardRef } from 'react';

import Counter, { CounterProps } from '@/lib/shared/components/Counter/Counter';

import cn from 'clsx';

import styles from './styles.module.scss';

interface Props extends CounterProps {
  label: string;
  tip?: string;
}

const CounterInput = forwardRef<HTMLDivElement, Props>(
  ({ className, label, tip, ...counterProps }, ref) => {
    return (
      <label className={cn(className, styles.label)}>
        <div>
          {label}
          {tip && <div className={styles.tip}>{tip}</div>}
        </div>
        <Counter ref={ref} {...counterProps} />
      </label>
    );
  }
);

CounterInput.displayName = 'CounterInput';

export default CounterInput;
